import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['item'];

	connect() {}

	toggle(e) {
		if (e.target.tagName == 'A') {
			return;
		}

		e.preventDefault();

		const item = e.target.closest('[data-accordion-target="item"]');

		if (item.dataset.groupToggle) {
			item.removeAttribute('data-group-toggle');
		} else {
			item.setAttribute('data-group-toggle', true);
		}
	}
}
